var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('InduksiViewEmail',{attrs:{"dataRowVisitor":_vm.dataRowVisitor,"dataRequestPermit":_vm.dataRequestPermit,"token":_vm.token}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }